module.exports = __webpack_public_path__ + "img/userLogo12.d47a96a8.jpg";